@if (fieldList && fieldList.length > 0 && durationField) {
  <form [formGroup]="carryForm">
    <table>
      <thead>
        <tr>
          <th class="CarryingCost__DurationFieldWrapper" colspan="2">
            <ng-container
              dynamicField
              [field]="durationField"
              [group]="carryForm"
              className="CarryingCost__DurationField"
            >
            </ng-container>
          </th>
        </tr>
        <tr>
          <th>Total</th>
          <th class="CarryingCost__MonthlyHeader">Monthly</th>
        </tr>
      </thead>
      <tbody>
        @for (field of fieldList; track field) {
          @if (field.name !== 'duration') {
            <tr>
              <td>
                {{
                  (carryForm.getRawValue()[field.name] || 0) *
                    (carryForm.value['duration'] || 1) | currency
                }}&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>
                <ng-container dynamicField [field]="field" [group]="carryForm">
                </ng-container>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </form>
}
